/*
 * This file is part of the nivo project.
 *
 * Copyright 2016-present, Raphaël Benitte.
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
import React from 'react';
import computeCalendar from '../../../lib/charts/calendar/CalendarLayout';
import { CalendarPropTypes } from './props';
import { timeFormat } from 'd3-time-format';
import { DIRECTION_HORIZONTAL } from '../../../constants/directions';
import CalendarDay from './CalendarDay';
import CalendarMonthPath from './CalendarMonthPath';
import Container from '../Container';
import SvgWrapper from '../SvgWrapper';
import enhance from './enhance';

var monthLegendFormat = timeFormat('%b');

var Calendar = function Calendar(_ref) {
    var data = _ref.data,
        from = _ref.from,
        to = _ref.to,
        colorScale = _ref.colorScale,
        margin = _ref.margin,
        width = _ref.width,
        height = _ref.height,
        outerWidth = _ref.outerWidth,
        outerHeight = _ref.outerHeight,
        direction = _ref.direction,
        emptyColor = _ref.emptyColor,
        yearSpacing = _ref.yearSpacing,
        yearLegendOffset = _ref.yearLegendOffset,
        daySpacing = _ref.daySpacing,
        dayBorderWidth = _ref.dayBorderWidth,
        dayBorderColor = _ref.dayBorderColor,
        monthBorderWidth = _ref.monthBorderWidth,
        monthBorderColor = _ref.monthBorderColor,
        monthLegendOffset = _ref.monthLegendOffset,
        theme = _ref.theme,
        isInteractive = _ref.isInteractive,
        tooltipFormat = _ref.tooltipFormat,
        onClick = _ref.onClick;

    var _computeCalendar = computeCalendar({
        width: width,
        height: height,
        from: from,
        to: to,
        data: data,
        direction: direction,
        colorScale: colorScale,
        emptyColor: emptyColor,
        yearSpacing: yearSpacing,
        daySpacing: daySpacing
    }),
        years = _computeCalendar.years,
        months = _computeCalendar.months,
        days = _computeCalendar.days;

    return React.createElement(
        Container,
        { isInteractive: isInteractive, theme: theme },
        function (_ref2) {
            var showTooltip = _ref2.showTooltip,
                hideTooltip = _ref2.hideTooltip;
            return React.createElement(
                SvgWrapper,
                { width: outerWidth, height: outerHeight, margin: margin },
                days.map(function (d) {
                    return React.createElement(CalendarDay, {
                        key: d.date.toString(),
                        data: d,
                        x: d.x,
                        y: d.y,
                        size: d.size,
                        color: d.color,
                        borderWidth: dayBorderWidth,
                        borderColor: dayBorderColor,
                        showTooltip: showTooltip,
                        hideTooltip: hideTooltip,
                        tooltipFormat: tooltipFormat,
                        theme: theme,
                        onClick: onClick
                    });
                }),
                months.map(function (m) {
                    return React.createElement(CalendarMonthPath, {
                        key: m.date.toString(),
                        path: m.path,
                        borderWidth: monthBorderWidth,
                        borderColor: monthBorderColor
                    });
                }),
                months.map(function (month) {
                    var transform = void 0;
                    if (direction === DIRECTION_HORIZONTAL) {
                        transform = 'translate(' + (month.bbox.x + month.bbox.width / 2) + ',' + (month.bbox.y - monthLegendOffset) + ')';
                    } else {
                        transform = 'translate(' + (month.bbox.x - monthLegendOffset) + ',' + (month.bbox.y + month.bbox.height / 2) + ') rotate(-90)';
                    }

                    return React.createElement(
                        'text',
                        {
                            key: month.date.toString() + '.legend',
                            className: 'nivo_calendar_month_legend',
                            transform: transform,
                            textAnchor: 'middle'
                        },
                        monthLegendFormat(month.date)
                    );
                }),
                years.map(function (year) {
                    var transform = void 0;
                    if (direction === DIRECTION_HORIZONTAL) {
                        transform = 'translate(' + (year.bbox.x - yearLegendOffset) + ',' + (year.bbox.y + year.bbox.height / 2) + ') rotate(-90)';
                    } else {
                        transform = 'translate(' + (year.bbox.x + year.bbox.width / 2) + ',' + (year.bbox.y - yearLegendOffset) + ')';
                    }

                    return React.createElement(
                        'text',
                        {
                            key: year.year,
                            className: 'nivo_calendar_year_legend',
                            transform: transform,
                            textAnchor: 'middle'
                        },
                        year.year
                    );
                })
            );
        }
    );
};

Calendar.propTypes = CalendarPropTypes;

export default enhance(Calendar);


//////////////////
// WEBPACK FOOTER
// ./node_modules/nivo/es/components/charts/calendar/Calendar.js
// module id = 527
// module chunks = 0